import { useTranslation } from "react-i18next";
import { Form } from "antd";
import Input from "components/inputs";
import config from "utils/globals";
import SubmitButton from "./button";

const NationalCodeForm = ({
  data,
  onFinishBaseInfo,
  formRef,
  loading,
  validator,
}) => {
  const { t } = useTranslation();
  // const [form] = Form.useForm();
  // const nationalSerial = Form.useWatch("national_serial", form);

  // const disabled = [null, "", undefined].includes(nationalSerial);

  const renderInputs = () => {
    return config.sortArray(data?.fields, "sort")?.map((item) => {
      return (
        <Input
          inputClassName="text-right"
          disabled={data.info_status !== "OPEN"}
          label={item?.title}
          name={item?.key}
          required={item?.is_required}
          type={item?.type !== "str" && "number"}
          validateTrigger="onSubmit"
          validateStatus={data?.status === "FAILED" && item?.message && "error"}
          // help={data?.status === "FAILED" && item?.message}
          placeholder={t("card-page.nationalcode-placeholder")}
          validator={validator}
          validateDebounce={500}
        />
      );
    });
  };

  return (
    <Form
      name="onboarding-step"
      onFinish={onFinishBaseInfo}
      autoComplete="off"
      ref={formRef}
      // form={form}
      initialValues={{
        national_serial: data?.fields.filter(
          (item) => item.key === "national_serial"
        )[0]?.value,
      }}
    >
      <div className="mx-5 pb-5 border-b border-gray--8 mb-4">
        {renderInputs()}
      </div>
      <SubmitButton loading={loading} />
    </Form>
  );
};

export default NationalCodeForm;
